import React, { useState } from 'react';
import { BrandMark } from './ui/Logo';
import Icon from './ui/Icon';

interface LoginScreenProps {
  onLogin: (token?: string) => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordLogin = async (pwd?: string) => {
    const loginPassword = pwd || password;
    if (!loginPassword.trim()) { setError('Введите пароль'); return; }

    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: loginPassword }),
      });
      const data = await response.json();
      if (response.ok && data.token) {
        localStorage.setItem('auth_token', data.token);
        onLogin(data.token);
      } else {
        setError('Неверный пароль');
      }
    } catch {
      setError('Ошибка подключения к серверу');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="cb-canvas" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: 24,
      fontFamily: 'var(--sans)',
    }}>
      <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: 380 }}>
        <div className="glass" style={{
          borderRadius: 'var(--r-xl)',
          padding: '40px 32px',
          boxShadow: 'var(--glass-shadow)',
        }}>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 32 }}>
              <BrandMark size="lg" />
              <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 8, fontFamily: 'var(--mono)' }}>
                мастерская
              </p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ position: 'relative' }}>
                <div style={{
                  position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
                  pointerEvents: 'none', opacity: 0.45, display: 'flex', alignItems: 'center',
                }}>
                  <Icon name="lock" size={16} color="var(--text0)" />
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handlePasswordLogin()}
                  placeholder="Пароль"
                  disabled={loading}
                  autoFocus
                  style={{
                    width: '100%',
                    padding: '11px 42px 11px 38px',
                    background: 'var(--input-bg)',
                    border: '1px solid var(--input-border)',
                    borderRadius: 'var(--r-sm)',
                    color: 'var(--text0)',
                    fontFamily: 'var(--sans)',
                    fontSize: 14,
                    outline: 'none',
                    boxSizing: 'border-box' as const,
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    transition: 'border-color 0.15s, background 0.15s',
                  }}
                  onFocus={e => { e.currentTarget.style.borderColor = 'var(--input-focus)'; }}
                  onBlur={e => { e.currentTarget.style.borderColor = 'var(--input-border)'; }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(v => !v)}
                  style={{
                    position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer',
                    padding: 4, display: 'flex', alignItems: 'center', opacity: 0.45,
                  }}
                >
                  <Icon name={showPassword ? 'eye-off' : 'eye'} size={16} color="var(--text0)" />
                </button>
              </div>

              {error && (
                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 8,
                  padding: '10px 12px',
                  background: 'var(--red-dim)',
                  border: '1px solid var(--red-mid)',
                  borderRadius: 'var(--r-sm)',
                }}>
                  <Icon name="alert" size={15} color="var(--red)" />
                  <span style={{ color: 'var(--red)', fontSize: 13, lineHeight: 1.5 }}>{error}</span>
                </div>
              )}

              <button
                onClick={() => handlePasswordLogin()}
                disabled={loading}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                  padding: '12px 20px',
                  borderRadius: 'var(--r-sm)',
                  border: 'none',
                  background: 'var(--teal-solid)',
                  color: 'rgba(0,0,0,0.85)',
                  fontFamily: 'var(--sans)',
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1,
                  boxShadow: '0 4px 16px var(--teal-mid)',
                  transition: 'opacity 0.15s',
                }}
              >
                <Icon name="check" size={16} color="rgba(0,0,0,0.85)" />
                {loading ? 'Вход...' : 'Войти'}
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
